import {
  NOTIFICATION_SHOW,
  NOTIFICATION_COMPLETED,
  SOTY_VOTE,
  SOTY_VOTE_SUCCESS,
  SOTY_VOTE_FAILED,
  SOTY_TOKEN_RECEIVE,
  SOTY_HISTORY_RECEIVE,
  SOTY_VOTE_POPUP_CLOSED,
} from '../actions';

export default (state, action) => {
  if (!state) {
    return {
      isVotingOpen: undefined,
      current: undefined,
      notificationQueue: [],
      soty_vote_popup: {
        voting: false,
        token: undefined,
        history: [],
      },
    };
  }

  switch (action.type) {
    case '__DANGEROUS_CONFIG_RECEIVE': {
      return {
        ...state,
        isVotingOpen: Boolean(action.market.shopOfTheYear.isVotingOpen),
      };
    }
    case NOTIFICATION_SHOW: {
      if (!state.current) {
        return {
          ...state,
          current: action.notification,
        };
      }
      return {
        ...state,
        notificationQueue: [...state.notificationQueue, action.notification],
      };
    }
    case NOTIFICATION_COMPLETED: {
      // Pop first from queue and populate 'current' if possible
      const notificationQueue = state.notificationQueue;
      const current = notificationQueue.shift();
      return {
        ...state,
        current,
        notificationQueue,
      };
    }
    case SOTY_TOKEN_RECEIVE: {
      return {
        ...state,
        soty_vote_popup: {
          ...state.soty_vote_popup,
          errors: {},
          token: {
            ...state.soty_vote_popup.token,
            ...action.token,
            email: action.email,
          },
        },
      };
    }
    case SOTY_VOTE: {
      return {
        ...state,
        soty_vote_popup: {
          ...state.soty_vote_popup,
          voting: true,
          voted: false,
        },
      };
    }

    case SOTY_VOTE_SUCCESS: {
      return {
        ...state,
        soty_vote_popup: {
          ...state.soty_vote_popup,
          voting: false,
          voted: true,
        },
      };
    }

    case SOTY_VOTE_FAILED: {
      return {
        ...state,
        soty_vote_popup: {
          ...state.soty_vote_popup,
          ...action.error,
          voting: false,
          voted: false,
        },
      };
    }

    case SOTY_HISTORY_RECEIVE: {
      return {
        ...state,
        soty_vote_popup: {
          ...state.soty_vote_popup,
          history: action.history,
        },
      };
    }

    case SOTY_VOTE_POPUP_CLOSED: {
      return {
        ...state,
        soty_vote_popup: {
          ...state.soty_vote_popup,
          voting: false,
          voted: false,
          errors: {},
        },
      };
    }

    case 'SESSION_RECEIVE': {
      return {
        ...state,
        soty_vote_popup: {
          ...state.soty_vote_popup,
          errors: {},
          token: action.session.soty,
        },
      };
    }

    case 'USER_RECEIVE': {
      return {
        ...state,
        soty_vote_popup: {
          ...state.soty_vote_popup,
          errors: {},
        },
      };
    }

    case 'LOGOUT_COMPLETE': {
      return {
        ...state,
        soty_vote_popup: {},
      };
    }
    default:
  }
  return state;
};
